<template>
  <footer class="modal-check">
    <md-checkbox
      v-model="check"
      @change="$emit('option', check)"
      class="md-primary"
    >
      <span class="text-dont-show">Don't show this again</span>
    </md-checkbox>
  </footer>
</template>

<script>
export default {
  name: "DontShowAgainModal",
  data() {
    return {
      check: false,
    };
  },
};
</script>

<style lang="scss" scoped>
.text {
  color: $black;
}
</style>

<style lang="scss">
.md-checked .md-checkbox-container {
  background-color: $primary !important;
  border-color: $primary !important;
}
.modal-check {
  margin-bottom: -2rem !important;
  margin-top: 2rem !important;
}
</style>
